import * as CommonActions from '../actions/CommonActions'
import { combineReducers } from 'redux'
import user from './UserReducer'
import booking from './BookingReducer'

// Updates error message to notify about the failed fetches.
const errorMessage = (state = null, action) => {
  const { type, error } = action

  if (type === CommonActions.RESET_ERROR_MESSAGE) {
    return null
  } else if (error) {
    return error
  }

  return state
}

const rootReducer = combineReducers({
  errorMessage,
  user,
  booking
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js